__turbopack_context__.v({
  "fallAndRotate": "_2uvVVG_fallAndRotate",
  "gift": "_2uvVVG_gift",
  "root": "_2uvVVG_root",
});
